import { Link } from '@tanstack/react-router'
import { Icon, cx } from '@algoboo/ui'
import { useUnreadCount } from '../lib/api'
import { useNotificationStream } from '../lib/notifications'
import { useSession } from './session'

/** Header bell for signed-in users: unread count from the API, kept live by the notification stream. */
export function NotificationBell() {
  const { me } = useSession()
  const signedIn = !!me
  const unread = useUnreadCount(signedIn)
  useNotificationStream(signedIn && unread.isSuccess)
  if (!signedIn) return null
  const n = unread.data?.count ?? 0
  const label = n > 0 ? `Notifications, ${n} unread` : 'Notifications'
  return (
    <Link
      to="/me/notifications"
      aria-label={label}
      title={label}
      data-testid="notification-bell"
      data-count={n}
      className="rh-hit relative inline-flex h-10 w-10 items-center justify-center rounded-[8px] text-ink-3 hover:bg-sunken hover:text-ink"
    >
      <Icon name="bell" size={18} />
      {n > 0 && (
        <span aria-hidden="true" className={cx('absolute right-1 top-1 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-accent px-1 font-mono text-[10px] font-semibold leading-none text-ink-inverse')}>
          {n > 99 ? '99+' : n}
        </span>
      )}
    </Link>
  )
}
